import request from './request'

export const getUserList = (params) => {
  return request({
    url: '/admin/user/users',
    method: 'get',
    params
  })
}

export const getUserDetail = (id) => {
  return request({
    url: `/admin/user/users/${id}`,
    method: 'get'
  })
}

export const updateUserStatus = (id, status) => {
  return request({
    url: `/admin/user/users/${id}`,
    method: 'put',
    data: { status }
  })
}

export const deleteUser = (id) => {
  return request({
    url: `/admin/user/users/${id}`,
    method: 'delete'
  })
}

export const adjustUserBalance = (id, data) => {
  return request({
    url: `/admin/user/users/${id}/adjust-balance`,
    method: 'post',
    data
  })
}
